import { Box } from '@material-ui/core';
import { Lender, Pricing } from '@nemuru-eng/js-api-client';

import { PricingsTable } from '@/components/shared/components/PricingsTable/PricingsTable';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';

interface PricingsTableProps {
  pricings: Pricing[];
  lenders: Lender[];
  page: number;
  setPage: (page: number) => void;
  refreshData: () => Promise<unknown>;
  defaultRowsPerPage?: number;
  selectPricing?: (pricingId: string) => void;
  editModeAllowed?: boolean;
  allowedRemovePricingFromAgent?: boolean;
}

export const PricingsListTable = ({
  pricings,
  lenders,
  page,
  setPage,
  defaultRowsPerPage = 10,
  selectPricing,
  allowedRemovePricingFromAgent,
  editModeAllowed = false,
  refreshData,
}: PricingsTableProps) => {
  return (
    <SubSectionWrapper title="AVAILABLE_PRICINGS">
      <Box mt={'10px'}>
        <PricingsTable
          pricings={pricings}
          lenders={lenders}
          page={page}
          setPage={setPage}
          refreshData={refreshData}
          defaultRowsPerPage={defaultRowsPerPage}
          allowedRemovePricingFromAgent={allowedRemovePricingFromAgent}
          selectPricing={selectPricing}
          editModeAllowed={editModeAllowed}
          forceEnabledRow
        />
      </Box>
    </SubSectionWrapper>
  );
};
